<template>
  <div class="courseTeaching-container">
    <div class="courseTeaching-frame">
      <!-- 课次列表部分开始 -->
      <div class="classTimesList">
        <!-- 输入课次搜索框 -->
        <div class="courseSearch-content">
          <div class="courseSearch-box flex align spaceBetween">
            <input v-model="courseName" @keyup.enter="courseSearch(courseName)" class="courseSearch" type="text"
              placeholder="输入课次名称" />
            <img @click="courseSearch(courseName)" class="searchIcon pointer"
              src="../../assets/resourceManagement/searchIcon.png" />
          </div>
        </div>
        <!-- 课次列表 -->
        <div class="classList-box">
          <!-- 课次列表标题 -->
          <div class="classTimesList-title-box flex align">
            <div class="classTimesList-block"></div>
            <div class="classTimesList-title">课次列表</div>
          </div>
          <!-- 课次列表 -->
          <div @click="singleClass(index)" :class="currentClassesIdx == index ? 'allClasses' : 'classList'"
            v-for="(item, index) in allListClasses" :key="index">
            <div class="classList-circle"></div>
            <div class="classList-num">课次{{ index + 1 }}</div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
          <!-- 考试列表标题 -->
          <div v-if="testPaperList.length > 0" class="classTimesList-title-box flex align">
            <div class="classTimesList-block"></div>
            <div class="classTimesList-title">考试列表</div>
          </div>
          <!-- 考试列表 -->
          <div @click="selectTestPaper(item)" :class="currentExamId == item.id ? 'allClasses' : 'classList'"
            v-for="(item) in testPaperList" :key="item.id">
            <div class="classList-circle"></div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 课次列表部分结束 -->
      <div v-if="currentClassesIdx != null" class="courseTeaching-content">
        <!-- 统计图部分开始 -->
        <div class="statistics-frame">
          <div class="statistics-box">
            <div class="echartsPie">
              <echartsPie ref="echartsPie1" :preData="preData[0]"></echartsPie>
            </div>
            <div class="echartsPie">
              <echartsPie ref="echartsPie2" :preData="preData[1]"></echartsPie>
            </div>
            <div class="echartsPie">
              <echartsPie ref="echartsPie3" :preData="preData[2]"></echartsPie>
            </div>
          </div>
          <div class="statistics-button-box pointer">
            <!-- <div @click="toDataStatistics" class="statistics-button">
              <img class="statistics-button-icon" src="@/assets/courseTeaching/icon1.png" />
              <p class="statistics-button-text">数据统计</p>
            </div>
            <div v-show="editableOrNot" @click="toExerciseReview" class="statistics-button pointer">
              <img class="statistics-button-icon" src="@/assets/courseTeaching/icon2.png" />
              <p class="statistics-button-text">习题批阅</p>
            </div> -->
            <div v-show="editableOrNot" @click="toAddResources" class="statistics-button pointer">
              <img class="statistics-button-icon" src="@/assets/courseTeaching/icon3.png" />
              <p class="statistics-button-text">添加资源</p>
            </div>
            <div v-show="editableOrNot" @click="toAddExercises" class="statistics-button pointer">
              <img class="statistics-button-icon" src="@/assets/courseTeaching/icon2.png" />
              <p class="statistics-button-text">添加习题</p>
            </div>
          </div>
        </div>
        <!-- 统计图部分结束 -->
        <!-- 资源列表部分开始 -->
        <div class="resourceList">
          <!-- 教学实施部分开始 -->
          <div class="resourceList-h1Box flex align">
            <div class="resourceList-colorBlock"></div>
            <div class="resourceList-h1">教学实施</div>
          </div>
          <!-- 课前准备部分开始 -->
          <div style="margin-top: 2px">
            <div class="resourceList-h2Box flex align">
              <div class="resourceList-round"></div>
              <div class="resourceList-h2">课前准备</div>
            </div>
            <el-table @row-click="handleRowClick" :data="beforeClassList" @selection-change="changeFun1"
              :row-style="{ height: '0.3rem' }" fit>
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="name" label="名称"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="types" label="类型"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="created" label="上传时间"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="score" label="分值"> </el-table-column>
              <el-table-column v-if="editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <el-button @click.stop="btnMove('beforeUp', scope.$index)" :disabled="scope.$index == 0" type="text"
                    icon="el-icon-top">上移</el-button>
                  <el-button @click.stop="btnMove('beforeDown', scope.$index)"
                    :disabled="beforeClassList.length - 1 == scope.$index" type="text"
                    icon="el-icon-bottom">下移</el-button>
                  <!-- <el-button @click.stop="deleteResources(scope.row)" type="text" icon="el-icon-delete-solid" style="color: red">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 课前准备部分结束 -->
          <!-- 课堂教学部分开始 -->
          <div>
            <div class="resourceList-h2Box flex align">
              <div class="resourceList-round"></div>
              <div class="resourceList-h2">课堂教学</div>
            </div>
            <el-table @row-click="handleRowClick" :data="middleClassList" @selection-change="changeFun2"
              :row-style="{ height: '0.3rem' }" fit>
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="name" label="名称"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="types" label="类型"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="created" label="上传时间"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="score" label="分值"> </el-table-column>
              <el-table-column v-if="editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <el-button @click.stop="btnMove('middleUp', scope.$index)" :disabled="scope.$index == 0" type="text"
                    icon="el-icon-top">上移</el-button>
                  <el-button @click.stop="btnMove('middleDown', scope.$index)"
                    :disabled="middleClassList.length - 1 == scope.$index" type="text"
                    icon="el-icon-bottom">下移</el-button>
                  <!-- <el-button @click.stop="deleteResources(scope.row)" type="text" icon="el-icon-delete-solid" style="color: red">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 课堂教学部分结束 -->
          <!-- 课后巩固部分开始 -->
          <div>
            <div class="resourceList-h2Box flex align">
              <div class="resourceList-round"></div>
              <div class="resourceList-h2">课后巩固</div>
            </div>
            <el-table @row-click="handleRowClick" :data="afterClassList" @selection-change="changeFun3"
              :row-style="{ height: '0.3rem' }" fit>
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="name" label="名称"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="types" label="类型"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="created" label="上传时间"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="score" label="分值"> </el-table-column>
              <el-table-column v-if="editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <el-button @click.stop="btnMove('afterUp', scope.$index)" :disabled="scope.$index == 0" type="text"
                    icon="el-icon-top">上移</el-button>
                  <el-button @click.stop="btnMove('afterDown', scope.$index)"
                    :disabled="afterClassList.length - 1 == scope.$index" type="text"
                    icon="el-icon-bottom">下移</el-button>
                  <!-- <el-button @click.stop="deleteResources(scope.row)" type="text" icon="el-icon-delete-solid" style="color: red">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 课后巩固部分结束 -->
          <!-- 教学实施部分结束 -->
          <div v-show="editableOrNot" class="flex justify">
            <div class="btnBox flex justify spaceBetween">
              <div @click="showChooseClass = true" class="pushButton pointer">发布</div>
              <div @click="classesBegin" class="pushButton pointer">开始上课</div>
            </div>
          </div>
        </div>
        <!-- 资源列表部分结束 -->
      </div>
      <div v-if="currentExamId != null" class="courseTeaching-content">
        <div class="testPaperInformation-box">
          <div class="testPaperInformation-title">作业信息</div>
          <div class="testPaperInformation-lineBox flex">
            <div class="flex">
              <div class="testPaperInformation-key">作业名称:</div>
              <div class="testPaperInformation-value">{{ testPaper.name }}</div>
            </div>
            <div class="flex">
              <div class="testPaperInformation-key">查看答案时机:</div>
              <div class="testPaperInformation-value">{{ testPaper.answer_limitTxt }}</div>
            </div>
          </div>
          <div class="testPaperInformation-lineBox flex">
            <div class="flex">
              <div class="testPaperInformation-key">考试起止时间:</div>
              <div class="testPaperInformation-value">{{ testPaper.start_StopTime }}</div>
            </div>
            <div class="flex">
              <div class="testPaperInformation-key">作业用途:</div>
              <div class="testPaperInformation-value">{{ testPaper.examUsage }}</div>
            </div>
          </div>
          <div class="testPaperInformation-lineBox flex">
            <div class="flex">
              <div class="testPaperInformation-key">作业题数:</div>
              <div class="testPaperInformation-value1">{{ testPaper.num_item }}</div>
            </div>
            <div class="flex">
              <div class="testPaperInformation-key">考试时长:</div>
              <div class="testPaperInformation-value1">{{ testPaper.testDuration }}</div>
            </div>
            <div class="flex">
              <div class="testPaperInformation-key">作业满分:</div>
              <div class="testPaperInformation-value1">{{ testPaper.score }}</div>
            </div>
          </div>
        </div>
        <div class="questionBankList-box">
          <div class="testPaperInformation-title">作业内容</div>
          <div class="exampleList" v-for="(item, index) in questionBankList" :key="index">
            <!-- 题干 -->
            <div class="flex align spaceBetween">
              <div class="flex align">
                <div class="questionNo">{{ index + 1 }}</div>
                <div class="topicType">{{ item.types }}</div>
              </div>
              <div class="flex align">
                <div class="score-txt">分值:</div>
                <div class="score-inputFrame flex justify">
                  <input disabled v-model="item.inputValue" class="score-input" type="text" />
                </div>
              </div>
            </div>
            <div class="stem">{{ item.content }}</div>
            <!-- 选项 -->
            <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="exampleList-option">
              <div v-for="(item, index) in item.options" :key="index">
                <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
              </div>
            </div>
            <!-- 答案 -->
            <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="answer flex align">
              <div class="answer-txt">答案:</div>
              <div class="answer-English">{{ item.answer1.toString().replaceAll(",", "、") }}</div>
            </div>
            <div v-if="item.types == '填空题'" class="answer flex align">
              <div class="answer-txt">答案:</div>
              <div class="blankAnswer" v-for="(item, index) in item.options" :key="index">第{{ index + 1 }}空: {{ item }}
              </div>
            </div>
            <!-- 解析 -->
            <div class="answer flex">
              <div class="answer-txt">解析:</div>
              <div class="answer-English">{{ item.comment }}</div>
            </div>
          </div>
          <div v-show="editableOrNot" class="flex justify">
            <div @click="showChooseClass = true" class="pushButton pointer">发布作业</div>
            <div @click="viewData" class="pushButton pointer" style="margin-left: 20px">查看数据</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择班级弹窗部分开始 -->
    <div v-show="showChooseClass" class="pop-chooseClass">
      <div class="chooseClass-frame">
        <img @click="showChooseClass = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="chooseClass-frame-title">选择班级</div>
        <div class="selectClass-box">
          <div class="gradediv">
            <div v-for="(item, index) in gradeDataList" @click="selectGrade(item)" :key="index" class="pointer">
              <p v-if="item === gradeName" class="gradediv_color1">{{ item }}</p>
              <p v-else class="gradediv_color2">{{ item }}</p>
            </div>
          </div>
          <div class="gradediv_class">
            <div v-for="(item, index) in classDataList" @click="selectClass(item.id)" :key="index"
              class="gradediv_classdiv pointer">
              <img v-if="checkClassList.indexOf(item.id) !== -1" class="gradediv_classimg"
                src="../../assets/classManagement/cm11.png" />
              <img v-else class="gradediv_classimg" src="../../assets/classManagement/cm10.png" />
              <p class="gradediv_classtxt">{{ item.name }}</p>
            </div>
          </div>
          <div class="flex justify">
            <div @click="courseRelease" class="pushButton pointer">确认发布</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择班级弹窗部分结束 -->
    <!-- 删除资源弹窗部分开始 -->
    <div v-show="showDeleteResources" class="pop-deleteResources">
      <div class="deleteResources">
        <img @click="showDeleteResources = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="deleteResourcesTxt">删除后课程中将无法继续使用此资源，确定要将删除吗？</div>
        <div @click="btnAffirm" class="btnAffirm pointer">确认</div>
      </div>
    </div>
    <!-- 删除资源弹窗部分结束 -->
  </div>
</template>

<script type="text/javascript">
import { Toast } from "vant";
// 接口
import { resourceList, resourceAssociationAdd, classList, publishClassResources, getExamList, obtainTeacherTeachingClass, gradeList, resourceAssociationDel, testPaperDetails } from "@/api";
// 组件
import echartsPie from "@/components/echarts_pie";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      showChooseClass: false, // 控制选择班级弹窗的显示
      checked: [], // 选择班级的id数组
      allListClasses: [], // 全部课次列表
      currentClassesIdx: 0, // 当前选中的课次
      beforeClassList: [], // 课前准备列表
      middleClassList: [], // 课堂教学列表
      afterClassList: [], // 课后巩固列表
      combinedData: [], // 资源和试题接口组合的数据
      testPapersList: [], // 作业列表
      gradeDataList: [], // 年级列表
      gradeName: "", // 选中的年级
      classDataList: [], // 年级对应的班级列表
      checkClassList: [], // 选中的班级列表
      classTableData: [], // 获取老师授课班级列表
      changeList1: [],
      changeList2: [],
      changeList3: [],
      changeList4: [],
      conversionData: "", // 资源转换后的数据
      resourceTotal: 0, // 资源总数
      examitemTotal: 0, // 试题总数
      examTotal: 0, // 试题总数
      courseName: "", // 课次搜索的课次名称
      showDeleteResources: false, // 是否展示删除资源弹窗
      deleteResourceLinkid: -1, // 选中删除的资源link_id
      preData: [
        {
          title: "资源统计",
          show: true,
          typeList: [
            { value: 0, name: "视频资源" },
            { value: 0, name: "音频资源" },
            { value: 0, name: "文档资源" },
            { value: 0, name: "图片资源" },
            { value: 0, name: "链接资源" },
          ],
          countLength: "",
        },
        {
          title: "习题统计",
          show: true,
          typeList: [
            { value: 0, name: "单选题" },
            { value: 0, name: "多选题" },
            { value: 0, name: "判断题" },
            { value: 0, name: "简答题" },
            { value: 0, name: "填空题" },
          ],
          countLength: "",
        },
        {
          title: "作业统计",
          show: true,
          typeList: [
            { value: 0, name: "手动选题" },
            { value: 0, name: "自动选题" },
          ],
          countLength: "",
        },
      ],
      testPaperList: [], // 作业列表
      currentExamId: null, // 当前选择的作业id
      testPaper: {}, // 当前选择的作业
      questionBankList: [], // 作业题库列表
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"], // 选项顺序
    };
  },
  created() {
    this.publicGetExam(); // 获取作业列表
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
    this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "题}";
    this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    // 调用获取年级列表接口
    gradeList().then((res) => {
      this.gradeDataList = res.data.datas; // 获取年级列表
      this.gradeName = res.data.datas[0];
      // 调用获取老师授课班级列表接口
      let params = { lesson_id: this.$store.state.courseDetails.id };
      obtainTeacherTeachingClass(params).then((res) => {
        for (let i in res.data.datas) {
          if (res.data.datas[i].grade == this.gradeName) {
            this.classDataList.push(res.data.datas[i]); // 获取老师授课班级列表
          }
        }
      });
    });
    // 班级列表
    classList().then((res) => {
      this.classList = res.data.datas;
    });
    // 获取当前课程全部课次的数据
    this.allListClasses = this.$store.state.classListRecord;
    // 资源列表提交的参数
    let params = {
      lesson_id: this.$store.state.courseDetails.id,
      lesson_item_id: this.allListClasses[0].id,
      types: "",
      page: 1,
      num: 1000,
      desc: ["sort", "id"],
    };
    this.publicClassResources(params);
  },
  components: { echartsPie },
  methods: {
    // 选择作业
    selectTestPaper(item) {
      this.currentClassesIdx = null; // 重置当前课次索引
      this.currentExamId = item.id; // 获取作业id
      this.testPaper = item; // 获取作业数据
      // 调用作业修改接口
      let params = { id: item.id };
      testPaperDetails(params).then((res) => {
        // 获取试题列表
        this.questionBankList = res.data.datas.exam_items.map((item) => {
          item.exam_item.inputValue = item.score;
          return item.exam_item;
        });
        // 数据转换:获取的数据
        for (let i = 0; i < this.questionBankList.length; i++) {
          let publicRes = this.questionBankList[i];
          publicRes.answer1 = [];
          for (let j = 0; j < publicRes.answer.length; j++) {
            publicRes.answer1[j] = this.optionOrder[publicRes.answer[j]]; // 题目答案获取
          }
          publicRes.content = publicRes.content.replace(/<[^>]+>/g, ""); // 题目题干获取
          publicRes.comment = publicRes.comment.replace(/<[^>]+>/g, ""); // 题目解析获取
          if (publicRes.types == "判断题") {
            publicRes.options[0] = "正确";
            publicRes.options[1] = "错误";
          }
          if (publicRes.types == "single") {
            publicRes.types = "单选题";
          } else if (publicRes.types == "multi") {
            publicRes.types = "多选题";
          } else if (publicRes.types == "truefalse") {
            publicRes.types = "判断题";
            publicRes.options[0] = "正确";
            publicRes.options[1] = "错误";
          } else if (publicRes.types == "answer") {
            publicRes.types = "简答题";
          } else if (publicRes.types == "blank") {
            publicRes.types = "填空题";
          }
        }
      });
    },
    // 公共获取作业
    publicGetExam() {
      // 调用获取作业列表接口
      let params = {
        where: [
          { k: "category", v: "exam", op: "=", lk: "and" },
          { k: "user_id", v: this.$store.state.loginRecord.data.datas.id, op: "=", lk: "and" },
          { k: "lesson_id", v: this.$store.state.courseDetails.id, op: "=", lk: "and" },
        ],
      };
      getExamList(params).then((res) => {
        if (res.data.code == 0) {
          this.testPaperList = res.data.datas.forEach((element) => {
            let startTime = element.time_begin.split("T")[0];
            let endTime = element.time_end.split("T")[0];
            element.start_StopTime = startTime + "—" + endTime; // 获取考试起止时间
            // console.log(element.start_StopTime);
            if (element.usage == "usually") {
              element.examUsage = "平时考试";
            } else if (element.usage == "mid") {
              element.examUsage = "期中考试";
            } else if (element.usage == "final") {
              element.examUsage = "期末考试";
            } else if (element.usage == "other") {
              element.examUsage = "其他考试";
            }
            if (element.answer_limit == "after") {
              element.answer_limitTxt = "交卷后可查看答案";
            } else if (element.answer_limit == "no") {
              element.answer_limitTxt = "不可查看答案";
            } else if (element.answer_limit == "time") {
              const formattedDate = element.answer_time.split("T")[0];
              element.answer_limitTxt = formattedDate + "后";
            }
            if (element.time_total == 0) {
              element.testDuration = "不限时";
            } else {
              element.testDuration = element.time_total + "分钟";
            }
          });
          this.testPaperList = res.data.datas;
        }
      });
    },
    // 上移下移按钮
    btnMove(type, index) {
      console.log(index);
      let before = this.beforeClassList;
      let up = before[index - 1];
      let now = before[index];
      let down = before[index + 1];
      let middle = this.middleClassList;
      let up1 = middle[index - 1];
      let now1 = middle[index];
      let down1 = middle[index + 1];
      let after = this.afterClassList;
      let up2 = after[index - 1];
      let now2 = after[index];
      let down2 = after[index + 1];
      if (type == "beforeUp") {
        let params = { id: now.link_id, sort: up.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: up.link_id, sort: now.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now.sort, up.sort] = [up.sort, now.sort];
        before.splice(index - 1, 2, now, up);
      } else if (type == "beforeDown") {
        let params = { id: now.link_id, sort: down.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: down.link_id, sort: now.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now.sort, down.sort] = [down.sort, now.sort];
        before.splice(index, 2, down, now);
      } else if (type == "middleUp") {
        let params = { id: now1.link_id, sort: up1.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: up1.link_id, sort: now1.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now1.sort, up1.sort] = [up1.sort, now1.sort];
        middle.splice(index - 1, 2, now1, up1);
      } else if (type == "middleDown") {
        let params = { id: now1.link_id, sort: down1.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: down1.link_id, sort: now1.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now1.sort, down1.sort] = [down1.sort, now1.sort];
        middle.splice(index, 2, down1, now1);
      } else if (type == "afterUp") {
        let params = { id: now2.link_id, sort: up2.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: up2.link_id, sort: now2.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now2.sort, up2.sort] = [up2.sort, now2.sort];
        after.splice(index - 1, 2, now2, up2);
      } else if (type == "afterDown") {
        let params = { id: now2.link_id, sort: down2.sort };
        resourceAssociationAdd(params).then((res) => { });
        let params1 = { id: down2.link_id, sort: now2.sort };
        resourceAssociationAdd(params1).then((res) => { });
        [now2.sort, down2.sort] = [down2.sort, now2.sort];
        after.splice(index, 2, down2, now2);
      }
      this.beforeClassList = before; // 获取调整位置后课前数据
    },
    // 点击行跳转资源数据页面
    handleRowClick(row) {
      this.$router.push({
        name: "resourceData",
        params: { details: row, classNumberId: this.allListClasses[this.currentClassesIdx].id },
      });
    },
    // 课次搜索
    courseSearch(name) {
      this.allListClasses = [];
      for (let i = 0; i < this.$store.state.classListRecord.length; i++) {
        if (this.$store.state.classListRecord[i].name.indexOf(name) >= 0) {
          this.allListClasses.push(this.$store.state.classListRecord[i]);
        }
      }
    },
    // 选择年级
    selectGrade(gradeName) {
      this.gradeName = gradeName;
      this.checkClassList = [];
      this.classDataList = [];
      // 调用获取老师授课班级列表接口
      let params = { lesson_id: this.$store.state.courseDetails.id };
      obtainTeacherTeachingClass(params).then((res) => {
        for (let i in res.data.datas) {
          if (res.data.datas[i].grade == this.gradeName) {
            this.classDataList.push(res.data.datas[i]); // 获取老师授课班级列表
          }
        }
      });
    },
    // 从班级库新增选择班级
    selectClass(classId) {
      if (this.checkClassList.indexOf(classId) === -1) {
        this.checkClassList.push(classId);
      } else {
        this.checkClassList.splice(this.checkClassList.indexOf(classId), 1);
      }
    },
    // 类型转换
    typeConversion(types) {
      if (types == "视频资源") {
        this.conversionData = "assets";
      } else if (types == "音频资源") {
        this.conversionData = "assets";
      } else if (types == "文档资源") {
        this.conversionData = "assets";
      } else if (types == "图片资源") {
        this.conversionData = "assets";
      } else if (types == "资源链接") {
        this.conversionData = "assets";
      } else if (types == "特殊互动") {
        this.conversionData = "assets";
      } else if (types == "单选题") {
        this.conversionData = "examitem";
      } else if (types == "多选题") {
        this.conversionData = "examitem";
      } else if (types == "判断题") {
        this.conversionData = "examitem";
      } else if (types == "简答题") {
        this.conversionData = "examitem";
      } else if (types == "填空题") {
        this.conversionData = "examitem";
      } else if (types == "作业-手动") {
        this.conversionData = "exam";
      } else if (types == "作业-自动") {
        this.conversionData = "exam";
      }
    },
    // 作业查看数据
    viewData() {
      this.$router.push({
        name: "testPaperData",
        params: { id: this.currentExamId },
      });
    },
    // 跳转到数据统计页面
    toDataStatistics() {
      this.$router.push({
        name: "dataStatistics",
        params: {},
      });
    },
    // 跳转到习题批阅页面
    toExerciseReview() {
      this.$router.push({
        name: "exerciseReview",
        params: {},
      });
    },
    // 添加资源
    toAddResources() {
      this.$router.push({
        name: "addResources",
        params: { comeFrom: "prepareLessons" },
      });
    },
    // 添加习题
    toAddExercises() {
      this.$router.push({
        name: "addExercises",
        params: { comeFrom: "prepareLessons" },
      });
    },
    // 发布
    courseRelease() {
      // 所选班级数据
      let total3 = "";
      for (let i = 0; i < this.checkClassList.length; i++) {
        total3 += this.checkClassList[i] + ",";
      }
      if (this.currentClassesIdx !== null) {
        let total1 = ""; // 资源id
        let total2 = ""; // 资源类型
        if (this.changeList1.length == 0 && this.changeList2.length == 0 && this.changeList3.length == 0 && this.changeList4.length == 0) {
          for (let i in this.beforeClassList) {
            // 课前准备资源id获取
            let { id } = this.beforeClassList[i];
            total1 += id + ",";
            // 课前准备资源类型获取
            let { types } = this.beforeClassList[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.middleClassList) {
            // 课堂教学资源id获取
            let { id } = this.middleClassList[i];
            total1 += id + ",";
            // 课堂教学资源类型获取
            let { types } = this.middleClassList[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.afterClassList) {
            // 课后巩固资源id获取
            let { id } = this.afterClassList[i];
            total1 += id + ",";
            // 课后巩固资源类型获取
            let { types } = this.afterClassList[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.testPapersList) {
            // 作业资源id获取
            let { id } = this.testPapersList[i];
            total1 += id + ",";
            // 作业资源类型获取
            let { types } = this.testPapersList[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
        } else {
          for (let i in this.changeList1) {
            // 课前准备资源id获取
            let { id } = this.changeList1[i];
            total1 += id + ",";
            // 课前准备资源类型获取
            let { types } = this.changeList1[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.changeList2) {
            // 课堂教学资源id获取
            let { id } = this.changeList2[i];
            total1 += id + ",";
            // 课堂教学资源类型获取
            let { types } = this.changeList2[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.changeList3) {
            // 课后巩固资源id获取
            let { id } = this.changeList3[i];
            total1 += id + ",";
            // 课后巩固资源类型获取
            let { types } = this.changeList3[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
          for (let i in this.changeList4) {
            // 作业资源id获取
            let { id } = this.changeList4[i];
            total1 += id + ",";
            // 作业资源类型获取
            let { types } = this.changeList4[i];
            this.typeConversion(types);
            total2 += this.conversionData + ",";
          }
        }
        // console.log("资源id:", total1);
        // console.log("资源类型:", total2);
        // console.log(total3);
        let data = {
          lesson_id: this.$store.state.courseDetails.id,
          lession_item_id: this.allListClasses[this.currentClassesIdx].id,
          resource_ids: total1,
          class_ids: total3,
          types: total2,
          category: "publish",
        };
        publishClassResources(data).then((res) => {
          if (res.data.code == 0) {
            Toast("发布成功！");
            this.showChooseClass = false;
          }
        });
      }
      if (this.currentExamId) {
        let data = {
          lesson_id: this.$store.state.courseDetails.id,
          class_ids: total3,
          resource_ids: this.currentExamId,
          types: "exam",
          category: "publish",
        };
        publishClassResources(data).then((res) => {
          if (res.data.code == 0) {
            Toast("发布成功！");
            this.showChooseClass = false;
          }
        });
      }
    },
    // 开始上课
    classesBegin() {
      let total1 = ""; // 资源id
      let total2 = ""; // 资源类型
      if (this.changeList1.length == 0 && this.changeList2.length == 0 && this.changeList3.length == 0 && this.changeList4.length == 0) {
        for (let i in this.beforeClassList) {
          // 课前准备资源id获取
          let { id } = this.beforeClassList[i];
          total1 += id + ",";
          // 课前准备资源类型获取
          let { types } = this.beforeClassList[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.middleClassList) {
          // 课堂教学资源id获取
          let { id } = this.middleClassList[i];
          total1 += id + ",";
          // 课堂教学资源类型获取
          let { types } = this.middleClassList[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.afterClassList) {
          // 课后巩固资源id获取
          let { id } = this.afterClassList[i];
          total1 += id + ",";
          // 课后巩固资源类型获取
          let { types } = this.afterClassList[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.testPapersList) {
          // 作业资源id获取
          let { id } = this.testPapersList[i];
          total1 += id + ",";
          // 作业资源类型获取
          let { types } = this.testPapersList[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
      } else {
        for (let i in this.changeList1) {
          // 课前准备资源id获取
          let { id } = this.changeList1[i];
          total1 += id + ",";
          // 课前准备资源类型获取
          let { types } = this.changeList1[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.changeList2) {
          // 课堂教学资源id获取
          let { id } = this.changeList2[i];
          total1 += id + ",";
          // 课堂教学资源类型获取
          let { types } = this.changeList2[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.changeList3) {
          // 课后巩固资源id获取
          let { id } = this.changeList3[i];
          total1 += id + ",";
          // 课后巩固资源类型获取
          let { types } = this.changeList3[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
        for (let i in this.changeList4) {
          // 作业资源id获取
          let { id } = this.changeList4[i];
          total1 += id + ",";
          // 作业资源类型获取
          let { types } = this.changeList4[i];
          this.typeConversion(types);
          total2 += this.conversionData + ",";
        }
      }
      // console.log("资源id:", total1);
      // console.log("资源类型:", total2);
      // 所选班级数据
      let total3 = "";
      // console.log(this.checkClassList);
      for (let i = 0; i < this.checkClassList.length; i++) {
        total3 += this.checkClassList[i] + ",";
      }
      let data = {
        lesson_id: this.$store.state.courseDetails.id,
        lession_item_id: this.allListClasses[this.currentClassesIdx].id,
        resource_ids: total1,
        class_ids: total3,
        types: total2,
        category: "lesson",
      };
      publishClassResources(data).then((res) => {
        if (res.data.code == 0) {
          if (this.changeList1.length == 0 && this.changeList2.length == 0 && this.changeList3.length == 0 && this.changeList4.length == 0) {
            this.$router.push({
              name: "classesBegin",
              params: {
                changeList1: this.beforeClassList,
                changeList2: this.middleClassList,
                changeList3: this.afterClassList,
                changeList4: this.testPapersList,
              },
            });
          } else {
            this.$router.push({
              name: "classesBegin",
              params: {
                changeList1: this.changeList1,
                changeList2: this.changeList2,
                changeList3: this.changeList3,
                changeList4: this.changeList4,
              },
            });
          }
        }
      });
    },
    //课前准备复选框状态改变
    changeFun1(val) {
      // console.log("课前准备数据:", val);
      this.changeList1 = val;
    },
    //课堂教学复选框状态改变
    changeFun2(val) {
      // console.log("课堂教学数据:", val);
      this.changeList2 = val;
    },
    //课后巩固复选框状态改变
    changeFun3(val) {
      // console.log("课后巩固数据:", val);
      this.changeList3 = val;
    },
    //作业复选框状态改变
    changeFun4(val) {
      // console.log("作业数据:", val);
      this.changeList4 = val;
    },
    // 公共接口调用方法
    publicClassResources(params) {
      // 资源列表数据
      this.combinedData = [];
      resourceList(params).then((res) => {
        for (let i in res.data.datas) {
          // 获取echarts图表数据
          if (res.data.datas[i].types == "assets") {
            this.resourceTotal++;
            this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.resourceTotal + "个}";
          } else if (res.data.datas[i].types == "examitem") {
            this.examitemTotal++;
            this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.examitemTotal + "题}";
          } else if (res.data.datas[i].types == "exam") {
            this.examTotal++;
            this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.examTotal + "个}";
          }
          // 获取列表数据
          if (res.data.datas[i].assets) {
            let publicRes = res.data.datas[i].assets;
            publicRes.typesOf = "资源";
            publicRes.link_id = res.data.datas[i].id;
            publicRes.sort = res.data.datas[i].sort || res.data.datas[i].id;
            // this.resourceList.push(res.data.datas[i].assets);
            // this.resourceList.push(res.data.datas[i].exam_item);
            // this.resourceList.push(res.data.datas[i].exam);
            publicRes.created = res.data.datas[i].created.substring(0, 10); // 转换日期格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "video") {
              this.preData[0].typeList[0].value++;
              publicRes.types = "视频资源";
            } else if (publicRes.types == "audio") {
              this.preData[0].typeList[1].value++;
              publicRes.types = "音频资源";
            } else if (publicRes.types == "doc") {
              this.preData[0].typeList[2].value++;
              publicRes.types = "文档资源";
            } else if (publicRes.types == "image") {
              this.preData[0].typeList[3].value++;
              publicRes.types = "图片资源";
            } else if (publicRes.types == "web") {
              this.preData[0].typeList[4].value++;
              publicRes.types = "资源链接";
            } else if (publicRes.types == "h5") {
              this.preData[0].typeList[4].value++;
              publicRes.types = "特殊互动";
            }
            this.combinedData.push(res.data.datas[i].assets);
          } else if (res.data.datas[i].exam_item) {
            let publicRes = res.data.datas[i].exam_item;
            publicRes.typesOf = "习题";
            publicRes.link_id = res.data.datas[i].id;
            publicRes.sort = res.data.datas[i].sort || res.data.datas[i].id;
            publicRes.created = res.data.datas[i].created.substring(0, 10); // 转换日期格式
            publicRes.name = publicRes.content.replace(/<[^>]+>/g, ""); // 转换名字格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "single") {
              this.preData[1].typeList[0].value++;
              publicRes.types = "单选题";
            } else if (publicRes.types == "multi") {
              this.preData[1].typeList[1].value++;
              publicRes.types = "多选题";
            } else if (publicRes.types == "truefalse") {
              this.preData[1].typeList[2].value++;
              publicRes.types = "判断题";
            } else if (publicRes.types == "answer") {
              this.preData[1].typeList[3].value++;
              publicRes.types = "简答题";
            } else if (publicRes.types == "blank") {
              this.preData[1].typeList[4].value++;
              publicRes.types = "填空题";
            }
            this.combinedData.push(res.data.datas[i].exam_item); // 将资源和试题两个接口的数据整合成一个数组
          } else if (res.data.datas[i].exam) {
            let publicRes = res.data.datas[i].exam;
            publicRes.typesOf = "作业";
            publicRes.link_id = res.data.datas[i].id;
            publicRes.sort = res.data.datas[i].sort || res.data.datas[i].id;
            publicRes.created = res.data.datas[i].created.substring(0, 10); // 转换日期格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            publicRes.num_item = publicRes.num_item + "道"; // 转换题数格式
            if (publicRes.types == "manual") {
              this.preData[2].typeList[0].value++;
              publicRes.types = "作业-手动";
            } else if (publicRes.types == "auto") {
              this.preData[2].typeList[1].value++;
              publicRes.types = "作业-自动";
            }
            this.combinedData.push(res.data.datas[i].exam); // 作业数据获取
          }
          // xiu.push(res.data.datas[i].assets);
        }
        this.beforeClassList = [];
        this.middleClassList = [];
        this.afterClassList = [];
        // console.log(this.combinedData.length);
        for (let i in this.combinedData) {
          // console.log(i, this.combinedData[i].usage);
          if (this.combinedData[i].usage == "front") {
            this.beforeClassList.push(this.combinedData[i]); // 课前准备数据获取
            this.beforeClassList = this.beforeClassList.sort((a, b) => b.sort - a.sort);
          } else if (this.combinedData[i].usage == "middle") {
            this.middleClassList.push(this.combinedData[i]); // 课堂教学数据获取
            this.middleClassList = this.middleClassList.sort((a, b) => b.sort - a.sort);
          } else if (this.combinedData[i].usage == "back") {
            this.afterClassList.push(this.combinedData[i]); // 课后巩固数据获取
            this.afterClassList = this.afterClassList.sort((a, b) => b.sort - a.sort);
          }
        }
        // console.log(this.combinedData);
        // console.log("课前准备数据:", this.beforeClassList);
        // console.log("课堂教学数据:", this.middleClassList);
        // console.log("课后巩固数据:", this.afterClassList);
      });
    },
    // 选中单个课次的逻辑
    singleClass(idx) {
      this.currentExamId = null;
      // 重置echarts图表的数据
      this.resourceTotal = 0; // 清空资源总数
      this.examitemTotal = 0; // 清空资源总数
      this.examTotal = 0; // 清空资源总数
      this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
      this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "题}";
      this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
      this.preData[0].typeList[0].value = 0;
      this.preData[0].typeList[1].value = 0;
      this.preData[0].typeList[2].value = 0;
      this.preData[0].typeList[3].value = 0;
      this.preData[0].typeList[4].value = 0;
      this.preData[1].typeList[0].value = 0;
      this.preData[1].typeList[1].value = 0;
      this.preData[1].typeList[2].value = 0;
      this.preData[1].typeList[3].value = 0;
      this.preData[1].typeList[4].value = 0;
      this.preData[2].typeList[0].value = 0;
      this.preData[2].typeList[1].value = 0;
      // 获取课次下标
      this.currentClassesIdx = idx;
      // 资源列表提交的参数
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: this.allListClasses[idx].id,
        types: "",
        page: 1,
        num: 1000,
      };
      this.publicClassResources(params);
    },
    // 删除资源
    deleteResources(data) {
      this.showDeleteResources = true;
      this.deleteResourceLinkid = data.link_id;
    },
    // 删除资源弹窗确认按钮调取删除资源接口并关闭弹窗
    btnAffirm() {
      let data = { link_resource_id: this.deleteResourceLinkid };
      resourceAssociationDel(data).then((res) => {
        if (res.data.code == 0) {
          Toast("已删除！");
          this.showDeleteResources = false;
          // 资源列表接口调取数据
          let params = {
            lesson_id: this.$store.state.courseDetails.id,
            lesson_item_id: this.allListClasses[this.currentClassesIdx].id,
            types: this.resourceType,
            page: 1,
            num: 1000,
          };
          this.publicClassResources(params);
        }
      });
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.courseTeaching-container {
  width: 100%;
  height: 100%;
  display: flex;
}

.courseTeaching-frame {
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
}

.courseTeaching-content {
  width: 1273px;
}

.statistics-frame {
  width: 100%;
  height: 295px;
  padding: 30px 40px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.statistics-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.statistics-button-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 230px;
}

.statistics-button {
  display: flex;
  align-items: center;
}

.statistics-button-icon {
  width: 20px;
  height: 20px;
}

.statistics-button-text {
  font-size: 18px;

  font-weight: bold;
  color: #349afe;
  margin-left: 10px;
}

.button-box {
  padding: 40px 0;
}

.button-icon {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  text-align: center;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  cursor: pointer;
}

/* 课次列表部分 */
.classTimesList {
  width: 466px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.courseSearch-content {
  padding: 20px 30px;
  box-sizing: border-box;
}

.searchIcon {
  width: 25px;
  height: 25px;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-block {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  height: calc(100vh - 220px);
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

/* 课次列表 */
.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

/* 资源列表部分 */
.resourceList {
  height: calc(100vh - 355px - 80px);
  overflow: auto;
}

.resourceList-h1Box {
  padding-left: 20px;
  height: 60px;
  background: #cce6ff;
}

.resourceList-colorBlock {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.resourceList-h1 {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.resourceList-h2Box {
  padding-left: 30px;
  height: 50px;
  background: #eaeaea;
}

.resourceList-round {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.resourceList-h2 {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 22px;
}

.btnBox {
  width: 410px;
  margin-top: 30px;
}

.pushButton {
  margin-top: 10px;
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

/* 选择班级弹窗 */
.pop-chooseClass {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.chooseClass-frame {
  position: relative;
  width: 761px;
  height: 500px;
  background: #ffffff;
  border-radius: 20px;
}

.chooseClass-frame-title {
  margin-top: 24px;
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
}

/* 选择班级组件 */
.selectClass-box {
  margin-top: 34px;
  width: 761px;
  height: 246px;
}

.selectClass-box-top {
  padding: 15px 47px;
  width: 761px;
  height: 50px;
  background: #f5f5f5;
  box-sizing: border-box;
}

.selectClassTxt {
  font-size: 20px;

  font-weight: 400;
  color: #000000;
}

.selectClass-class {
  padding: 19px 0 0 26px;
  box-sizing: border-box;
  width: 761px;
  height: 196px;
  display: grid;
  grid-template-columns: repeat(5, 104px);
  grid-template-rows: repeat(3, 20px);
  grid-column-gap: 44px;
  grid-row-gap: 30px;
}

.classTimes-box {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-bottom: 10px;
}

.gradediv {
  width: 100%;
  height: 50px;
  margin-top: 34px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  overflow: hidden;
  overflow-x: scroll;
  white-space: nowrap;
}

.gradediv_color1 {
  color: #349afe;
}

.gradediv_color2 {
  color: #000000;
}

.gradediv_class {
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  margin-top: 22px;
  margin-left: 33px;
  overflow: auto;
}

.gradediv_classdiv {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-bottom: 33px;
  margin-right: 44px;
}

.gradediv_classimg {
  width: 20px;
  height: 20px;
}

.gradediv_classtxt {
  font-size: 18px;
  font-weight: 400;
  color: #555555;
  margin-left: 10px;
}

/* 删除课程弹窗 */
.pop-deleteResources {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteResources {
  position: relative;
  width: 761px;
  height: 300px;
  background: #ffffff;
  border-radius: 20px;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 23px;
  height: 23px;
}

.deleteResourcesTxt {
  position: absolute;
  width: 550px;
  height: 83px;
  font-size: 30px;

  font-weight: 400;
  color: #000000;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btnAffirm {
  position: absolute;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  top: 217px;
  left: 50%;
  transform: translateX(-50%);
}

.btnDelete {
  width: 68px;
  height: 20px;
}

.btnMove {
  width: 59px;
  height: 20px;
}

.echartsPie {
  width: 355px;
  height: 178px;
}

.testPaperInformation-box {
  height: 239px;
  padding: 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.testPaperInformation-title {

  font-weight: 400;
  font-size: 22px;
  color: #349afe;
}

.testPaperInformation-key {
  margin-left: 21px;

  font-weight: 600;
  font-size: 22px;
  color: #555555;
  line-height: 22px;
}

.testPaperInformation-value {
  width: 400px;
  margin-left: 20px;

  font-weight: 400;
  font-size: 22px;
  color: #555555;
  line-height: 22px;
}

.testPaperInformation-value1 {
  width: 250px;
  margin-left: 20px;

  font-weight: 400;
  font-size: 22px;
  color: #555555;
  line-height: 22px;
}

.testPaperInformation-lineBox {
  margin-top: 30px;
}

/* 习题列表 */
.exampleList {
  padding: 20px 0px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.topicType {
  margin-left: 32px;
  font-weight: normal;
  font-size: 18px;
  color: #999999;
  line-height: 12px;
}

.questionNo {
  font-weight: normal;
  font-size: 18px;
  color: #000000;
  line-height: 18px;
}

.stem {
  margin-left: 59px;
  margin-top: 15px;
  font-weight: normal;
  font-size: 18px;
  color: #000000;
  line-height: 28px;
}

.score-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

.score-inputFrame {
  margin-left: 9px;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 5px;
}

.score-input {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.exampleList-option {
  margin-top: 15px;
  margin-left: 59px;
  border-left: 4px solid #dddddd;
  padding-left: 15px;
}

.exampleList-option-txt {
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

.answer {
  margin-top: 14px;
  margin-left: 59px;
}

.answer-txt {
  width: 47px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.answer-English {
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.blankAnswer {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.questionBankList-box {
  height: calc(100% - 239px);
  padding: 30px;
  box-sizing: border-box;
  overflow: auto;
}
</style>
